import { render } from "./Proveedores.vue?vue&type=template&id=1357c309&scoped=true"
import script from "./Proveedores.vue?vue&type=script&lang=js"
export * from "./Proveedores.vue?vue&type=script&lang=js"

import "./Proveedores.vue?vue&type=style&index=0&id=1357c309&scoped=true&lang=scss"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1357c309"]])

export default __exports__